Ext.define('SA.view.pvt.LocationDropdown', {
    alias: 'widget.pvt-location-dropdown',
    extend: 'SA.view.ComboButton',

    cls: 'sa-pvt-location-dropdown',
    emptyText: 'None',
    htmlEncode: false,
    menuCls: 'sa-pvt-location-dropdown-menu',
    ui: 'underline',

    menu: {
        defaults: {
            encodeText: false
        }
    },

    textTpl: [
        '<tpl if="values.type === \'combination\' || values.type === \'radius\'">',
            '<span class="sa-pvt-location-dropdown-icon-wrap">',
                '<svg class="sa-pvt-location-dropdown-icon">',
                    '<tpl if="type === \'combination\'">',
                        '<use href="#sa-icon-combination-location"></use>',
                    '<tpl elseif="type === \'radius\'">',
                        '<use href="#sa-icon-radius-location"></use>',
                    '</tpl>',
                '</svg>',
            '</span>',
        '</tpl>',
        '{.:locationRenderer}'
    ],

    getItem() {
        var value = this.value;

        if (!Ext.isObject(value)) {
            return this.callParent();
        }

        return this.items.filter(Ext.isObject).find(item => SA.data.LocationsCache.sameLocation(item, value));
    },

    updateText(location) {
        var text = location ? Ext.XTemplate.getTpl(this, 'textTpl').apply(location) : 'None';

        this.setText(text);
    }
});
